module.exports = __webpack_public_path__ + "img/icon-1.8013c936.png";